import { ChamberMemberProInvoicePaymentTermsEnum } from "../../../graphql/types";

const getPaymentTermOffsetDays = (
  invoicePaymentTerms: ChamberMemberProInvoicePaymentTermsEnum
) => {
  if (invoicePaymentTerms === ChamberMemberProInvoicePaymentTermsEnum.Net_30) {
    return 30;
  }

  if (invoicePaymentTerms === ChamberMemberProInvoicePaymentTermsEnum.Net_45) {
    return 45;
  }

  return 0;
};

export const getInvoiceDueDateInput = ({
  invoicePaymentTerms,
  issueDate,
}: {
  invoicePaymentTerms: ChamberMemberProInvoicePaymentTermsEnum;
  issueDate: string;
}) => {
  const match = issueDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (!match) {
    return issueDate;
  }

  const [, year, month, day] = match;
  const date = new Date(
    Date.UTC(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0)
  );

  date.setUTCDate(
    date.getUTCDate() + getPaymentTermOffsetDays(invoicePaymentTerms)
  );

  return date.toISOString().slice(0, 10);
};
